import { AlertSnippetDto } from '../../interfaces/IEvent'
import { AlertSendStatus } from '../../interfaces/IAlert'

/**
 * Build a map of recipient-id (customer number, phone number, or email)
 * to the list of previously sent alerts that notified that recipient on
 * the current event. Used to highlight previously notified recipients in
 * the create-alert flow.
 */
export function buildCustomerAlertHistory(alerts: AlertSnippetDto[] | undefined): Map<string, AlertSnippetDto[]> {
  const history = new Map<string, AlertSnippetDto[]>()
  const addAlertFor = (id: string, alert: AlertSnippetDto) => {
    const existing = history.get(id)
    if (existing) existing.push(alert)
    else history.set(id, [alert])
  }
  alerts
    ?.filter(
      (a) =>
        (a.status === AlertSendStatus.Sent || a.status === AlertSendStatus.SentPartially) && a.notifiedCustomers,
    )
    .forEach((a) => {
      a.notifiedCustomers?.companyCustomerIds?.forEach((id) => addAlertFor(id, a))
      a.notifiedCustomers?.companyWithSlaCustomerIds?.forEach((id) => addAlertFor(id, a))
      a.notifiedCustomers?.privateCustomerIds?.forEach((id) => addAlertFor(id, a))
      a.phoneNumbers?.forEach((n) => addAlertFor(n, a))
      a.emailAddresses?.forEach((e) => addAlertFor(e, a))
    })
  return history
}

/**
 * Like buildCustomerAlertHistory but includes ALL alert statuses (drafts, pending, sent, etc.).
 * Used for filtering — lets operators filter by drafts/scheduled alerts, not just sent ones.
 */
export function buildFullAlertHistory(alerts: AlertSnippetDto[] | undefined): Map<string, AlertSnippetDto[]> {
  const history = new Map<string, AlertSnippetDto[]>()
  const addAlertFor = (id: string, alert: AlertSnippetDto) => {
    const existing = history.get(id)
    if (existing) existing.push(alert)
    else history.set(id, [alert])
  }
  alerts
    ?.filter((a) => a.notifiedCustomers)
    .forEach((a) => {
      a.notifiedCustomers?.companyCustomerIds?.forEach((id) => addAlertFor(id, a))
      a.notifiedCustomers?.companyWithSlaCustomerIds?.forEach((id) => addAlertFor(id, a))
      a.notifiedCustomers?.privateCustomerIds?.forEach((id) => addAlertFor(id, a))
      a.phoneNumbers?.forEach((n) => addAlertFor(n, a))
      a.emailAddresses?.forEach((e) => addAlertFor(e, a))
    })
  return history
}
